/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CarrierGetAllReq } from '../models/carrier-get-all-req';
import { CarrierGetAllResp } from '../models/carrier-get-all-resp';
import { GetCustomFieldsReq } from '../models/get-custom-fields-req';
import { GetCustomFieldsResp } from '../models/get-custom-fields-resp';
import { GetExtraReq } from '../models/get-extra-req';
import { GetExtraResp } from '../models/get-extra-resp';

@Injectable({
  providedIn: 'root',
})
export class CarrierService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation carrierGetAll
   */
  static readonly CarrierGetAllPath = '/carrier/get-all';

  /**
   * Carrier
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `carrierGetAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  carrierGetAll$Response(params?: {
    body?: CarrierGetAllReq
  }): Observable<StrictHttpResponse<CarrierGetAllResp>> {

    const rb = new RequestBuilder(this.rootUrl, CarrierService.CarrierGetAllPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CarrierGetAllResp>;
      })
    );
  }

  /**
   * Carrier
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `carrierGetAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  carrierGetAll(params?: {
    body?: CarrierGetAllReq
  }): Observable<CarrierGetAllResp> {

    return this.carrierGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<CarrierGetAllResp>) => r.body as CarrierGetAllResp)
    );
  }

  /**
   * Path part for operation getCustomFields
   */
  static readonly GetCustomFieldsPath = '/carrier/custom-fields';

  /**
   * Custom fields of an carrier
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomFields()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCustomFields$Response(params: {
    body: GetCustomFieldsReq
  }): Observable<StrictHttpResponse<GetCustomFieldsResp>> {

    const rb = new RequestBuilder(this.rootUrl, CarrierService.GetCustomFieldsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetCustomFieldsResp>;
      })
    );
  }

  /**
   * Custom fields of an carrier
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCustomFields$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCustomFields(params: {
    body: GetCustomFieldsReq
  }): Observable<GetCustomFieldsResp> {

    return this.getCustomFields$Response(params).pipe(
      map((r: StrictHttpResponse<GetCustomFieldsResp>) => r.body as GetCustomFieldsResp)
    );
  }

  /**
   * Path part for operation getExtra
   */
  static readonly GetExtraPath = '/carrier/extra';

  /**
   * Custom fields of an carrier
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExtra()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getExtra$Response(params: {
    body: GetExtraReq
  }): Observable<StrictHttpResponse<GetExtraResp>> {

    const rb = new RequestBuilder(this.rootUrl, CarrierService.GetExtraPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetExtraResp>;
      })
    );
  }

  /**
   * Custom fields of an carrier
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getExtra$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getExtra(params: {
    body: GetExtraReq
  }): Observable<GetExtraResp> {

    return this.getExtra$Response(params).pipe(
      map((r: StrictHttpResponse<GetExtraResp>) => r.body as GetExtraResp)
    );
  }

}
